import { CanvasElementType, CanvasObjectPosition, CanvasObjectSize, CanvasObjectStyles } from '@y42/json-schema';
import type { VisualizationCanvasElementStoreModel } from '../visualization-canvas-element.model';
import { defaultCanvasGenericStyles } from './default-canvas-model-properties';

const canvasShapeStylesDefaultConstant: CanvasObjectStyles = {
  ...defaultCanvasGenericStyles,
  'border-width': '1',
  'background-color': '#6fd8b2',
  'border-color': '#5a9deb',
};

export const defaultShapeSize: CanvasObjectSize = {
  width: 300,
  height: 300,
};

export function getCanvasShapeModel(data: {
  position: CanvasObjectPosition;
  shapePath: string;
  size?: CanvasObjectSize;
}) {
  return {
    type: CanvasElementType.Shape,
    size: data.size || defaultShapeSize,
    typeSettings: { shapePath: data.shapePath },
    styles: canvasShapeStylesDefaultConstant,
    position: data.position,
  };
}

export type CanvasShapeModel = VisualizationCanvasElementStoreModel<CanvasElementType.Shape>;
